import signedFetch from '../util/signedFetch.js';

const getSearchUsersUrl = all => (all ? `${__API_BASE__}/user/query?format=all` : `${__API_BASE__}/user/query`);

export default (data, all = false) => signedFetch('searchUsers', getSearchUsersUrl(all), 'POST', data);
